import { HierarchyReference } from '@totem/components/services/threats/configuration/types';

// Mirrors ticketing-library models.TicketAssignment ("ticketing_assignments"). Each entry is mirrored by a
// TICKET / CREATED rule with the same id; only the first matching Active entry (by sequence) that resolves an
// Assignee claims the ticket ("ASSIGNMENT" claim key) -- otherwise the next matching entry gets its chance.
export interface TicketAssignmentMatch {
  type: string;
  category: string;
  subCategory: string;
  summaryContains: string; // Case-insensitive "contains"
}

export interface TicketAssignmentAssignee {
  partyType: string; // Assignee, Watcher, ...
  type: string; // ASSIGNEE_TYPE_* (templateManagement/types)
  value: string; // Contact label, department or email; blank for CREATOR
  notify: boolean;
}

export interface TicketAssignment {
  id: string;
  name: string;
  status: string;
  sequence: number;
  hierarchy: HierarchyReference;
  match: TicketAssignmentMatch;
  assignees: TicketAssignmentAssignee[];
  notes: string;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
}

export interface TicketAssignmentTestRequest {
  type: string;
  category: string;
  subCategory: string;
  summary: string;
  organizationId: string;
  buildingId: string;
  creatorEmail: string;
}

export interface TicketAssignmentTestPerson {
  partyType: string;
  name: string;
  email: string;
  assigneeType: string;
  value: string;
}

export interface TicketAssignmentTestResult {
  assignment: TicketAssignment;
  active: boolean;
  fulfilled: boolean;
  applied: boolean;
  people: TicketAssignmentTestPerson[];
}

export const TICKET_ASSIGNMENT_STATUS_OPTIONS = ['Active', 'Inactive'];

export const PARTY_TYPE_ASSIGNEE = 'Assignee';
export const PARTY_TYPE_WATCHER = 'Watcher';

// Party types an entry can add people as; the first is the default for a new row
export const TICKET_ASSIGNMENT_PARTY_TYPES = [
  PARTY_TYPE_ASSIGNEE,
  PARTY_TYPE_WATCHER,
  'Customer Assignee',
  'Project Manager',
  'Site Contact',
];

// Below the 100 that generic TICKET rules use, so assignment entries run ahead of them
export const DEFAULT_SEQUENCE = 50;
